import axios from 'axios';
import { ApiEndpoints } from './urls';
import { drfQueryParams } from './utils';

class icalApi {
  static getUserUrls(props) {
    const {
      id, page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.userICal.replace(':id:', id), {
      params
    });
  }

  static getItem({ id }) {
    return axios.get(ApiEndpoints.userICalItem.replace(':id:', id));
  }

  static createItem(params) {
    return axios.post(ApiEndpoints.userICalItem.replace(':id:/', ''), params);
  }

  static deleteItem({ id }) {
    return axios.delete(ApiEndpoints.userICalItem.replace(':id:', id));
  }
}

export default icalApi;
